import { useRef } from 'react';
import styles from './Popover.module.css';

export const Popover = ({ isOpen, onClose, title, children }: PopoverProps) => {
  const popoverRef = useRef<HTMLDivElement>(null);

  if (!isOpen) {
    return null;
  }

  return (
    <div ref={popoverRef} className={styles.popover}>
      {title && (
        <div className={styles.header}>
          <span className={styles.title}>{title}</span>
          <button className={styles.closeButton} onClick={onClose} type="button" aria-label="Sluiten">
            ✕
          </button>
        </div>
      )}
      <div className={styles.content}>{children}</div>
    </div>
  );
};

export type PopoverProps = {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
};
